"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var SiteSearchSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M4,8 L4,14 L9,14 L9,15 L4,15 C3.44771525,15 3,14.5522847 3,14 L3,5 C3,4.44771525 3.44771525,4 4,4 L14,4 C14.2761424,4 14.5261424,4.11192881 14.7071068,4.29289322 C14.8880712,4.47385763 15,4.72385763 15,5 L15,8 L4,8 Z M14,7 L14,5 L4,5 L4,7 L14,7 Z M13,15 C11.3431458,15 10,13.6568542 10,12 C10,10.3431458 11.3431458,9 13,9 C14.6568542,9 16,10.3431458 16,12 C16,12.6479152 15.7946045,13.2478577 15.445374,13.7382672 L16.8535534,15.1464466 C17.0488155,15.3417088 17.0488155,15.6582912 16.8535534,15.8535534 C16.6582912,16.0488155 16.3417088,16.0488155 16.1464466,15.8535534 L14.7382672,14.445374 C14.2478577,14.7946045 13.6479152,15 13,15 Z M13,14 C14.1045695,14 15,13.1045695 15,12 C15,10.8954305 14.1045695,10 13,10 C11.8954305,10 11,10.8954305 11,12 C11,13.1045695 11.8954305,14 13,14 Z" })));
};
SiteSearchSmall.displayName = 'SiteSearchSmall';
exports.default = SiteSearchSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=SiteSearchSmall.js.map